"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Range = exports.RangeConfig = exports.RangeFieldType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const NumberFromString_1 = require("io-ts-types/lib/NumberFromString");
const validators_1 = require("../../../validators");
exports.RangeFieldType = "Range";
exports.RangeConfig = t.exact(t.partial({
    label: validators_1.StringOrNull,
    placeholder: t.string,
    min: t.union([t.number, NumberFromString_1.NumberFromString]),
    max: t.union([t.number, NumberFromString_1.NumberFromString]),
    step: t.union([t.number, NumberFromString_1.NumberFromString]),
}));
exports.Range = t.exact(t.intersection([
    t.type({
        type: t.literal(exports.RangeFieldType),
    }),
    t.partial({
        fieldset: validators_1.StringOrNull,
        config: exports.RangeConfig,
    }),
]));
